const BASE = '';

function getToken() {
  return localStorage.getItem('token');
}

function setToken(token) {
  localStorage.setItem('token', token);
}

function clearToken() {
  localStorage.removeItem('token');
}

async function request(method, path, body = null) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const opts = { method, headers };
  if (body !== null) opts.body = JSON.stringify(body);

  const res = await fetch(`${BASE}/api${path}`, opts);

  // Token expired or invalid — force logout
  if (res.status === 401) {
    clearToken();
    window.location.href = '/';
    return;
  }

  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }

  return data;
}

// Shorthand methods
const api = {
  get:    (path)         => request('GET',    path),
  post:   (path, body)   => request('POST',   path, body),
  put:    (path, body)   => request('PUT',    path, body),
  patch:  (path, body)   => request('PATCH',  path, body),
  delete: (path)         => request('DELETE', path),

  // Auth
  login: (username, password) =>
    request('POST', '/config/login', { username, password }),

  // File upload (multipart — no JSON headers)
  upload: async (path, formData) => {
    const token = getToken();
    const headers = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const res = await fetch(`${BASE}/api${path}`, {
      method: 'POST',
      headers,
      body: formData
    });

    if (res.status === 401) {
      clearToken();
      window.location.href = '/';
      return;
    }

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || `Upload failed (${res.status})`);
    return data;
  }
};

// Format currency — ₹1,20,000
function formatINR(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) return '—';
  const num = Math.abs(Number(amount));
  const formatted = num.toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  });
  return (Number(amount) < 0 ? '−' : '') + '₹' + formatted;
}

// Format date — 01 Jan 2026
function formatDate(dateStr) {
  if (!dateStr) return '—';
  const d = new Date(dateStr + 'T00:00:00');
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

// Format date for input[type=date]
function toInputDate(dateStr) {
  if (!dateStr) return '';
  return dateStr.slice(0, 10);
}

// Days label
function daysLabel(days) {
  if (days === null || days === undefined) return '—';
  if (days < 0)  return `${Math.abs(days)}d overdue`;
  if (days === 0) return 'Today';
  return `${days}d`;
}

// Urgency class from days_until_renewal
function renewalUrgencyClass(days) {
  if (days <= 7)  return 'red';
  if (days <= 20) return 'orange';
  if (days <= 45) return 'amber';
  return 'ok';
}

// Status badge class
function statusClass(status) {
  switch (status) {
    case 'Ongoing':   return 'badge-green';
    case 'Incoming':  return 'badge-blue';
    case 'Completed': return 'badge-gray';
    case 'Dropped':   return 'badge-red';
    default:          return 'badge-gray';
  }
}

export {
  api, getToken, setToken, clearToken,
  formatINR, formatDate, toInputDate,
  daysLabel, renewalUrgencyClass, statusClass
};
